/**
 * Beat-the-Pro opponent nano-id auth. Minted per hole-competition opponent
 * (the pro), sent in SMS, used on the public `/b/:opponentKey/*` routes.
 * Rides in localStorage so the Apollo `opponent-key` link can read it lazily
 * on every request. Kept separate from the player key so the two audiences
 * never collide on a shared device.
 */

const OPPONENT_STORAGE_KEY = 'polf-opponent-key'

export const getOpponentKey = (): string | null => {
  if (typeof window === 'undefined') return null
  return window.localStorage.getItem(OPPONENT_STORAGE_KEY)
}

export const setOpponentKey = (key: string): void => {
  if (typeof window === 'undefined') return
  window.localStorage.setItem(OPPONENT_STORAGE_KEY, key)
}
